import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "overflow-x-auto rounded-lg border border-gray-200" }
const _hoisted_2 = { class: "w-full border-collapse" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("thead", { class: "bg-gray-100 text-xs font-semibold text-gray-600" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "py-3 px-4 text-left w-16" }, "No."),
    /*#__PURE__*/_createElementVNode("th", { class: "py-3 px-4 text-left w-1/4" }, "Min. Jumlah Penumpang"),
    /*#__PURE__*/_createElementVNode("th", { class: "py-3 px-4 text-left w-1/4" }, "Max. Jumlah Penumpang"),
    /*#__PURE__*/_createElementVNode("th", { class: "py-3 px-4 text-left w-1/3" }, "Komisi (Rp)"),
    /*#__PURE__*/_createElementVNode("th", { class: "py-3 px-4 text-center w-20" }, "AKSI")
  ])
], -1)
const _hoisted_4 = { class: "divide-y divide-gray-200" }
const _hoisted_5 = { class: "py-3 px-4 text-sm text-gray-700 font-medium" }
const _hoisted_6 = { class: "py-3 px-4" }
const _hoisted_7 = {
  key: 0,
  class: "text-xs text-red-500 mt-1"
}
const _hoisted_8 = { class: "py-3 px-4" }
const _hoisted_9 = {
  key: 0,
  class: "text-xs text-red-500 mt-1"
}
const _hoisted_10 = { class: "py-3 px-4" }
const _hoisted_11 = { class: "p-inputgroup flex-1" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, "Rp", -1)
const _hoisted_13 = {
  key: 0,
  class: "text-xs text-red-500 mt-1"
}
const _hoisted_14 = { class: "py-3 px-4 text-center" }
const _hoisted_15 = ["disabled", "onClick", "title"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-trash text-lg" }, null, -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = {
  key: 0,
  class: "text-xs text-red-500 mt-2"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-plus text-xs" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", null, "Tambah Komisi", -1)
const _hoisted_21 = [
  _hoisted_19,
  _hoisted_20
]


import InputNumber from 'primevue/inputnumber'
import { ITierRow } from '@/utils/interfaces/iSalesAgentCommission'


export default /*#__PURE__*/_defineComponent({
  __name: 'FormTierTable',
  props: {
    tiers: null,
    tiersGeneralError: null
  },
  emits: ["tier-input", "blur-tiers", "add-tier", "remove-tier"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'tier-input', tier: ITierRow, field: 'minPassenger' | 'maxPassenger' | 'commissionAmount', val: any): void
  (e: 'blur-tiers'): void
  (e: 'add-tier'): void
  (e: 'remove-tier', idx: number): void
}), expose: any, slots: any, attrs: any }) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("table", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("tbody", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tiers, (tier, idx) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: idx,
              class: "hover:bg-gray-50/50"
            }, [
              _createElementVNode("td", _hoisted_5, _toDisplayString(idx + 1), 1),
              _createElementVNode("td", _hoisted_6, [
                _createVNode(_unref(InputNumber), {
                  modelValue: tier.minPassenger,
                  placeholder: "0",
                  min: 0,
                  class: "w-full",
                  inputClass: tier.errorMin ? 'p-invalid w-full' : 'w-full',
                  onInput: (e) => emit('tier-input', tier, 'minPassenger', e),
                  "onUpdate:modelValue": (val) => emit('tier-input', tier, 'minPassenger', val),
                  onBlur: _cache[0] || (_cache[0] = () => emit('blur-tiers'))
                }, null, 8, ["modelValue", "inputClass", "onInput", "onUpdate:modelValue"]),
                (tier.errorMin)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(tier.errorMin), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("td", _hoisted_8, [
                _createVNode(_unref(InputNumber), {
                  modelValue: tier.maxPassenger,
                  placeholder: "0",
                  min: 0,
                  class: "w-full",
                  inputClass: tier.errorMax ? 'p-invalid w-full' : 'w-full',
                  onInput: (e) => emit('tier-input', tier, 'maxPassenger', e),
                  "onUpdate:modelValue": (val) => emit('tier-input', tier, 'maxPassenger', val),
                  onBlur: _cache[1] || (_cache[1] = () => emit('blur-tiers'))
                }, null, 8, ["modelValue", "inputClass", "onInput", "onUpdate:modelValue"]),
                (tier.errorMax)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(tier.errorMax), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("td", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createVNode(_unref(InputNumber), {
                    modelValue: tier.commissionAmount,
                    placeholder: "0",
                    min: 0,
                    max: 99999,
                    locale: "id-ID",
                    class: "w-full",
                    inputClass: tier.errorCommission ? 'p-invalid w-full' : 'w-full',
                    onInput: (e) => emit('tier-input', tier, 'commissionAmount', e),
                    "onUpdate:modelValue": (val) => emit('tier-input', tier, 'commissionAmount', val),
                    onBlur: _cache[2] || (_cache[2] = () => emit('blur-tiers'))
                  }, null, 8, ["modelValue", "inputClass", "onInput", "onUpdate:modelValue"])
                ]),
                (tier.errorCommission)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(tier.errorCommission), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("td", _hoisted_14, [
                _createElementVNode("button", {
                  type: "button",
                  disabled: idx !== __props.tiers.length - 1,
                  class: _normalizeClass(idx === __props.tiers.length - 1
                  ? 'text-red-500 hover:text-red-700 p-2 rounded-lg hover:bg-red-50 transition-colors cursor-pointer'
                  : 'text-gray-300 p-2 rounded-lg cursor-not-allowed opacity-40'),
                  onClick: () => emit('remove-tier', idx),
                  title: idx === __props.tiers.length - 1 ? 'Hapus Tier' : 'Hanya baris paling bawah yang dapat dihapus'
                }, _hoisted_17, 10, _hoisted_15)
              ])
            ]))
          }), 128))
        ])
      ])
    ]),
    (__props.tiersGeneralError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(__props.tiersGeneralError), 1))
      : _createCommentVNode("", true),
    _createElementVNode("button", {
      type: "button",
      class: "mt-3 inline-flex items-center gap-2 px-4 py-2 border border-blue-500 text-blue-500 rounded-lg text-sm font-semibold hover:bg-blue-50 transition-colors",
      onClick: _cache[3] || (_cache[3] = () => emit('add-tier'))
    }, _hoisted_21)
  ]))
}
}

})